<template>
    <vTransactionComponent :postList="postList" v-if="flag"></vTransactionComponent>
</template>
<script>
import vTransactionComponent from '../../listComponent/basicdata/transaction/transactionComponent.vue';
export default {
    name: 'transaction',
    components: {
        vTransactionComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                type: true,
                date: true,
                status: true,
                supplier_rid: true,
                demander_rid: true,
                partner_rid: true,
                product_rid: true,
                promotion_type: true,
                ppa_code: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>